<div *ngIf="this.canShowExport">

	<div class="buttons-container">
		<div kendoTooltip>
			<div [attr.title]="exportExcelLabel">
				<button kendoButton class="k-button executive-btns" (click)="togglePopup(true, true)"
					[disabled]="exportExcelDisabled" [svgIcon]="projectService.svgIcons.fileExcelIcon">
				</button>
			</div>
		</div>

		<div kendoTooltip *ngIf="showBOMExport">
			<div [attr.title]="exportBOMLabel">
				<button kendoButton class="k-button" (click)="togglePopup(true, false)" [svgIcon]="projectService.svgIcons.barcodeOutlineIcon"
					[disabled]="bomExportDisabled">
				</button>
			</div>
		</div>

	</div>
</div>

<kendo-dialog [title]="dialogTitle" *ngIf="isPopupShown" (close)="cancel()" [width]="850" [height]="1100">
	<app-offer></app-offer>
	<kendo-dialog-actions *ngIf="!exportInProgress">
		<button kendoButton (click)="cancel()" i18n="Dialogs|'Cancel' button">Cancel</button>
		<button kendoButton (click)="export()" primary="true" i18n="Dialogs|'Confirm' button">Confirm</button>
	</kendo-dialog-actions>
	<app-wait [show]="exportInProgress" message=""></app-wait>
</kendo-dialog>

<kendo-dialog *ngIf="!exportInProgress && isStatusDialogOpened" [width]="300" style="text-align: center">
	<div class="row">
		<div class="col-9">
			<h6 [ngClass]="exportSuccess ? 'success' : 'error'">{{ statusDialogMessage }}</h6>
		</div>
		<div class="col-3" *ngIf="statusDialogMessage">
			<kendo-svg-icon [icon]="getIcon()" [ngClass]="exportSuccess ? 'success-icon' : 'error-icon'"></kendo-svg-icon>
		</div>
	</div>
	<kendo-dialog-actions>
		<button kendoButton (click)="closePopup()" primary="true" i18n="Dialogs|'Confirm' button">Ok</button>
	</kendo-dialog-actions>
</kendo-dialog>
